import { Component, OnInit } from '@angular/core';
import { filter } from 'lodash';
import { Feature } from 'ol';
import { Observable } from 'rxjs';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { ArincFOMEnum } from 'src/app/models/ArincFOMEnum';
import { AntennaTypes, NavaidStatus } from 'src/app/models/EnumTypes';
import { FilterModel } from 'src/app/models/filter';
import { FreqConversionUtil } from 'src/app/models/FreqConversionUtil';
import { icaoccModel } from 'src/app/models/icaoccModel';
import { Filter } from 'src/app/popup/configure-flight-inpection-format/configure-flight-inpection-format.component';
import { MapService } from 'src/app/services/map.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { NavaidsFilterService } from 'src/app/services/navaids-filter.service';
import { NavaidsService } from 'src/app/services/navaids.service';
import { PointsService } from 'src/app/services/points.service';
import { TabsService } from 'src/app/services/tabsService';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { FiltersOfType, UserSettingsService } from 'src/app/services/userSettings.service';

@Component({
  selector: 'app-navaids-filter',
  templateUrl: './navaids-filter.component.html',
  styleUrls: ['./navaids-filter.component.scss'],
  standalone: false
})
export class NavaidsFilterComponent implements OnInit {

  selectedField : string;
  selectedValue : string;
  values : string[] = [];
  valuesIcao : icaoccModel[] = [];
  filterBy: String = "";



  dropdown_values_enabled : boolean = true;
  min_max_enabled : boolean = false;
  min_max_date_enabled : boolean = false;

  publishedString: string;
  showPublishedSlider: boolean = false;
  isPublishedSliderChecked: boolean = false;

  errorMessage: string[] = [null, null, null, null];

  constructor(public navaidsFilterController : NavaidsFilterService,
     public menuController : MenuManagementService,
     private toolsService : ToolsControlService,
     public navaidService : NavaidsService,
     public pointsService : PointsService,
     private modalService : ModalControlService,
     public tabsService: TabsService,
     private uiBlock: UiBlockService,
     private userSettingsService: UserSettingsService,
     private mapService: MapService,
     ) { }

  ngOnInit(): void {
    this.typeChanged('type');
    this.createInputHandlers();

    //get all navaids
      this.navaidsFilterController.windowOpened$.subscribe(() => {
      this.forceFilterRefresh();
    });

  }

  forceFilterRefresh(): void {


    //if navaids filter active
    this.uiBlock.startBlock("Getting Navaidss...");
    if (this.navaidsFilterController.filters.length > 0){
          this.pointsService.fetchTotalNavaidsCount();
          this.pointsService.deleteNavaidsFromMap();
          this.pointsService.fetchAndAddNavaids();
    }else {
        this.pointsService.getNavaidsCount().subscribe((count) => {
        this.pointsService.totalNavaidsInProject = count;
        this.pointsService.informationMessageNavaids = "Displaying " + count + " of " + count + ".";
    });

    }
    this.uiBlock.stopBlock();

  }



  fillIcaoEcacENP() : void {

  }

  createInputHandlers(){
    // get HTML elements
    const minValue = document.getElementById("min_value");
    const maxValue = document.getElementById("max_value");
    const minDate = document.getElementById("min_date");
    const maxDate = document.getElementById("max_date");

    // functions to handle input events

    const handleParameters = function(e) {
      let dateMin : Date = null;
      let dateMax : Date = null;
      switch (e.target.id){
        case "min_value":
          if (e.target.valueAsNumber < 0 ){
            this.errorMessage[0] = "Parameter Min Value cannot be less than 0";
          } else if (e.target.valueAsNumber > 60000){
            this.errorMessage[0] = "Parameter Min Value cannot be greater than 60000";
          } else if (e.target.valueAsNumber > (<HTMLInputElement>maxValue).valueAsNumber){
            this.errorMessage[0] = "Parameter Min Value cannot be greater than Max Value";
            this.errorMessage[1] = "Parameter Max Value cannot be less than Min Value";
            break;
          } else { // if input is correct
            this.errorMessage[0] = null;
          }
          if (Number((<HTMLInputElement>maxValue).valueAsNumber) >= 0 && Number((<HTMLInputElement>maxValue).valueAsNumber) <= 60000 ){
            this.errorMessage[1] = null;
          }
          break;
        case "max_value":
          if (e.target.valueAsNumber <= 0 ){
            this.errorMessage[1] = "Parameter Max Value cannot be less than 0";
          } else if (e.target.valueAsNumber > 60000){
            this.errorMessage[1] = "Parameter Max Value cannot be greater than 60000";
          } else if ( e.target.valueAsNumber < (<HTMLInputElement>minValue).valueAsNumber){
            this.errorMessage[0] = "Parameter Min Value cannot be greater than Max Value";
            this.errorMessage[1] = "Parameter Max Value cannot be less than Min Value";
            break;
          } else { // if input is correct
            this.errorMessage[1] = null;
          }
          if (Number((<HTMLInputElement>minValue).valueAsNumber) >= 0 && Number((<HTMLInputElement>minValue).valueAsNumber) <= 60000){
            this.errorMessage[0] = null;
          }
          break;
        case "min_date":
          try {
            dateMin = new Date(e.target.value);
            if (dateMin.getFullYear() > 2100){
              this.errorMessage[2] = "Date Year cannot be greater than 2100";
            } else { // if input is correct
              this.errorMessage[2] = null;
            }
            dateMax = new Date((<HTMLInputElement>maxDate).value);
          } catch (e) {
            break;
          }
          if (dateMax < dateMin){
            this.errorMessage[2] = "Parameter Min Date cannot be greater than Max Date";
            this.errorMessage[3] = "Parameter Max Date cannot be less than Min Date";
          } else { // if input is correct
            if (dateMax.getFullYear() <= 2100){
              this.errorMessage[3] = null;
            }
          }
          break;
        case "max_date" :
          try {
            dateMax = new Date(e.target.value);
            if (dateMax.getFullYear() > 2100){
              this.errorMessage[3] = "Date Year cannot be greater than 2100";
            } else { // if input is correct
              this.errorMessage[3] = null;
            }
            dateMin = new Date((<HTMLInputElement>minDate).value);
          } catch (e) {
            break;
          }
          if (dateMax < dateMin){
            this.errorMessage[3] = "Parameter Max Date cannot be less than Min Date";
            this.errorMessage[2] = "Parameter Min Date cannot be greater than Max Date";
          } else { // if input is correct
            if (dateMin.getFullYear() <= 2100){
              this.errorMessage[2] = null;
            }
          }
          break;
      }
    }
    // input event listeners for values
    minValue.addEventListener('input', handleParameters.bind(this));
    maxValue.addEventListener('input', handleParameters.bind(this));
    // input event listeners for date fields
    minDate.addEventListener('input', handleParameters.bind(this));
    maxDate.addEventListener('input', handleParameters.bind(this));
  }

  showErrorMessage(){
    for (const error of this.errorMessage){
      if (error != null && error != ""){
        this.modalService.showMesssageModal('', error);
        return false
      }
    }
    return true;
  }

  public typeChanged( $event ) {
    this.values = [];
    this.valuesIcao = [];
    this.filterBy = $event;
    switch($event){
      case 'icao_ecac_enp':
        this.valuesIcao = this.navaidsFilterController.ecacEnpIcaoCodes;
        this.showPublishedSlider = false;
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        break;
      case 'icao_world':
        this.valuesIcao = this.navaidsFilterController.worldIcaoCodes;
        this.showPublishedSlider = false;
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        break;
      case 'doc':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = true;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'doc_max':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = true;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'eirp':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = true;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'output_power':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = true;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'type':
        this.values.push("DME");
        this.values.push("VOR/DME");
        this.values.push("TACAN");
        this.values.push("VORTAC");
        this.values.push("DME (ILS)");
        this.values.push("VOR");
        this.values.push("NDB");
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'operational_status':
        this.values.push(NavaidStatus.OPERATIONAL.html);
        this.values.push(NavaidStatus.PLANNED.html);
        this.values.push(NavaidStatus.DECOMMISSIONED.html);
        this.values.push(NavaidStatus.OUT_OF_SERVICE.html);
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'operational_at_date':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = false;
        this.min_max_date_enabled = true;
        this.showPublishedSlider = false;
        break;
      case 'date_comissioning':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = false;
        this.min_max_date_enabled = true;
        this.showPublishedSlider = false;
        break;
      case 'date_replacement':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = false;
        this.min_max_date_enabled = true;
        this.showPublishedSlider = false;
        break;
      case 'planned_removal':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = false;
        this.min_max_date_enabled = true;
        this.showPublishedSlider = false;
        break;
      case 'purpose':
        this.values.push("ENR");
        this.values.push("TMA");
        this.values.push("ENR&TMA");
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'published':
        this.values.push("User Defined");
        this.values.push("Published");
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = true;
        break;
      case 'vhf_frequency':
        FreqConversionUtil.channelFreqList.forEach( item => {
          if(item.vorFreq != null){
            this.values.push(item.vorFreq.toString());
          }
        });
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'channel':
        FreqConversionUtil.channelFreqList.forEach( item => {
          if(item.vorFreq != null){
            this.values.push(item.channel);
          }
        });
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'fom':
        const keys = Object.values(ArincFOMEnum);
        keys.forEach((value, index) => {
          this.values.push(value);
        });
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'vor_operational_status':
        this.values.push(NavaidStatus.OPERATIONAL.html);
        this.values.push(NavaidStatus.PLANNED.html);
        this.values.push(NavaidStatus.DECOMMISSIONED.html);
        this.values.push(NavaidStatus.OUT_OF_SERVICE.html);
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'vor_operational_at_date':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = false;
        this.min_max_date_enabled = true;
        this.showPublishedSlider = false;
        break;
      case 'vor_operational_comissioning':
      this.dropdown_values_enabled = false;
      this.min_max_enabled = false;
      this.min_max_date_enabled = true;
      this.showPublishedSlider = false;
      break;
      case 'vor_replacement':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = false;
        this.min_max_date_enabled = true;
        this.showPublishedSlider = false;
        break;
      case 'vor_planned_removal':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = false;
        this.min_max_date_enabled = true;
        this.showPublishedSlider = false;
        break;
      case 'vor_type':
        this.values.push("Conventional");
        this.values.push("Doppler");
        this.dropdown_values_enabled = true;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'bias':
        this.dropdown_values_enabled = false;
        this.min_max_enabled = true;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      case 'antenna_type':
        this.dropdown_values_enabled = true;
        this.values.push(...Object.values(AntennaTypes))
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
        break;
      default:
        this.dropdown_values_enabled = false;
        this.min_max_enabled = false;
        this.min_max_date_enabled = false;
        this.showPublishedSlider = false;
    }
  }

  selectFeaturesOnMap() : void {
    if (this.navaidsFilterController.filters.length > 0){
      this.pointsService.filterNavaids(this.navaidsFilterController.filters, false);
    }
  }

  async applyFilter() {
    this.navaidService.loading = true;
    if (this.navaidsFilterController.filters.length > 0) {
      for (const filter of this.navaidsFilterController.filters) {
        if (filter.field == 'Selected Navaids on the map') {
          filter.navaidsSelectedOnMapId = this.pointsService.getSelectedNavaids().map(n => n.id);
        }
        filter.active = true;
      }
      await this.pointsService.filterNavaids(this.navaidsFilterController.filters, true).then( result => {
        setTimeout( () => {this.navaidService.loading = false}, 1000);
      });
      this.userSettingsService.updateFilters(FiltersOfType.Navaids,this.navaidsFilterController.filters);
      const extent = this.mapService.getCurrentExtent();
      await this.pointsService.fetchAndAddNavaids();
    }else {
      this.navaidService.loading = false;
    }
  }

  async resetFilters() {
    if (this.navaidsFilterController.filters.length === 0) {
      return;
    }
    this.navaidService.loading = true;
    this.navaidsFilterController.filters = [];
    this.userSettingsService.updateFilters(FiltersOfType.Navaids,this.navaidsFilterController.filters);
    this.pointsService.deleteNavaidsFromMap();
    const extent = this.mapService.getCurrentExtent();
    this.pointsService.getNavaidsPartial(extent).subscribe((navaids) => {
      navaids.forEach((element) => {
        this.pointsService.addNavaidToMap(element);
      })
      this.pointsService.informationMessageNavaids = "Displaying " + this.pointsService.totalNavaidsInProject + " of " + this.pointsService.totalNavaidsInProject + ".";
      this.navaidService.loading = false;
    });
  }
  addFilter() : void {
    let filter_item : FilterModel = new FilterModel();

    if (this.filterBy === 'published') {
      filter_item.field = 'Published';
      filter_item.value = this.isPublishedSliderChecked ? 'published' : 'userdefined';
    }

    let selected = document.getElementById("filter_type") as HTMLSelectElement;
    if (selected != null){
      filter_item.field = selected.options[selected.selectedIndex].text;
    }

    if (this.dropdown_values_enabled) {
      filter_item.value = (<HTMLInputElement>document.getElementById("values")).value;
    } else if (this.min_max_enabled) {
      filter_item.value = (<HTMLInputElement>document.getElementById("min_value")).value + " < " + filter_item.field + " < " + (<HTMLInputElement>document.getElementById("max_value")).value;
    } else if (this.min_max_date_enabled) {
      filter_item.value = (<HTMLInputElement>document.getElementById("min_date")).value + " < " + filter_item.field + " < " + (<HTMLInputElement>document.getElementById("max_date")).value;
    }


    this.navaidsFilterController.filters.push(filter_item);
  }

  updatePublishedLabel(): string {
    return this.isPublishedSliderChecked ? 'Published' :'User Defined';
  }

  selectFilter(filter : FilterModel) {
    this.navaidsFilterController.filters.forEach( elm => {
      if((filter.field == elm.field) && (filter.value == elm.value)){
        elm.isSelected = true;
      }else {
        elm.isSelected = false;
      }
    });
  }

  async deleteSelectedFilterFromList(){
    const hasSelectedFilters = this.navaidsFilterController.filters.some(item => item.isSelected);
    if (!hasSelectedFilters) {
      return; // Do nothing if there are no selected filters
    }
    this.navaidsFilterController.filters.forEach(function(item, index, object) {
      if (item.isSelected) {
        object.splice(index, 1);
      }
    });
    this.userSettingsService.updateFilters(FiltersOfType.Navaids,this.navaidsFilterController.filters);
    const extent = this.mapService.getCurrentExtent();
    await this.pointsService.fetchAndAddPartialNavaids(extent);
  }

  cancelWindow():void{
    this.navaidsFilterController.active = !this.navaidsFilterController.active;
    this.toolsService.navigationOnTop = false;
  }

}
